<form [formGroup]="formGroup">
  <div class="wrapping-group">
    <mat-form-field class="privileged">
      <mat-label>{{ 'name' | i18nextCap }}</mat-label>
      <input matInput type="text" formControlName="name" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'externalId' | i18nextCap }}</mat-label>
      <input matInput type="text" formControlName="externalId" />
    </mat-form-field>
  </div>
  <div class="wrapping-group">
    <mat-form-field>
      <mat-label>{{ 'type' | i18nextCap }}</mat-label>
      <mat-select formControlName="type">
        <mat-option value="SUPPLIER">{{ 'SUPPLIER' | i18nextCap }}</mat-option>
        <mat-option value="CLIENT">{{ 'CLIENT' | i18nextCap }}</mat-option>
        @if (bothTypeAllowed) {
          <mat-option value="BOTH">{{ 'BOTH' | i18nextCap }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'forms:nif' | i18nextCap }}</mat-label>
      <input matInput type="text" formControlName="nif" />
      @if (formGroup.controls.nif.errors != null) {
        <mat-error>{{
          formGroup.controls.nif.errors.message | i18nextCap
        }}</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="privileged">
      <mat-label>{{ 'assignees' | i18nextCap }}</mat-label>
      <mat-select multiple formControlName="assignees" [compareWith]="idsEqual">
        @for (a of potentialAssignees; track a.id) {
          <mat-option [value]="a">
            {{ a.firstName }} {{ a.lastName }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <mat-form-field>
    <mat-label>{{ 'forms:country' | i18nextCap }}</mat-label>
    <mat-select formControlName="country" [compareWith]="idsEqual">
      @for (c of countries; track c.id) {
        <mat-option [value]="c">{{ c.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <div class="wrapping-group">
    <mat-form-field>
      <mat-label>{{ 'email' | i18nextCap }}</mat-label>
      <input matInput type="text" formControlName="email" />
      @if (formGroup.controls.email.errors != null) {
        <mat-error>{{
          formGroup.controls.email.errors.message | i18nextCap
        }}</mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'phone' | i18nextCap }}</mat-label>
      <input matInput type="text" formControlName="phone" />
    </mat-form-field>
  </div>
  <mat-form-field>
    <mat-label>{{ 'website' | i18nextCap }}</mat-label>
    <input matInput type="text" formControlName="website" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'notes' | i18nextCap }}</mat-label>
    <textarea matInput formControlName="notes"></textarea>
  </mat-form-field>
  <button
    type="button"
    mat-flat-button
    color="primary"
    [disabled]="formGroup.invalid || disabled"
    (click)="onClickSave()"
  >
    {{ 'save' | i18nextCap }}
  </button>
</form>
